import 'babel-polyfill'// 使用polyfill兼容ie浏览器
import Vue from 'vue'
import './utils/directives'
import 'normalize.css/normalize.css' // CSS浏览器兼容插件，确保各种浏览器兼容

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // echarts theme
import App from './App'
import store from './store'
import router from './router'
// const router = require('vue-router')
// import VueLodash from 'vue-lodash'
import _ from 'lodash'
import i18n from './lang'
import '@/icons' // icon
import '@/permission' //  路由校验
import permission from '@/directive/permission'

import { dragMove } from '@/directive/dragMove'
// const Vue = require('vue') // global css
import echarts from 'echarts'
import VueClipBoard from 'vue-clipboard2'
import components from '@/components'
// require('../public/tinymce.min.js') //  富文本编辑器引入

// const echarts = require('echarts')
// require('echarts/theme/macarons') // 权限控制
/**
 * This project originally used easy-mock to simulate data,
 * but its official service is very unstable,
 * and you can build your own service if you need it.
 * So here I use Mock.js for local emulation,
 * it will intercept your request, so you won't see the request in the network.
 * If you remove `../mock` it will automatically request easy-mock data.
 */
// import '../mock' // simulation data
Vue.use(echarts, { i18n: (key, value) => i18n.t(key, value) })
Vue.use(ElementUI)
Vue.use(VueClipBoard)
// Vue.use(VueLodash)
Vue.prototype._ = _
Vue.directive('ismove', dragMove)
Vue.directive('permission', permission)
Vue.config.productionTip = false
console.log(store)
// 注册全局组件
Vue.use(components)

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
